<template>
  <div>
    <Title title="九吨大事记"></Title>
    <div class="page5-box " ref="scrollbox" @scroll="handleScroll">
      <ul class="ul-box">
        <li class="item" :ref="`scrollItem_${index}`" v-for="(item, index) in  list " :key="index">
          <div class="content" :style="{ '--top': index % 2 != 0 ? '0.6667rem' : '-2.6667rem' }">
            <p class="desc">
              {{ item.title }}
            </p>
            <p class="date">
              {{ item.date.split(' ')[0] }}
            </p>
          </div>
        </li>
      </ul>
    </div>


    <!-- 切换按钮 -->
    <div class="cutover space-between ac">
      <div class="left ajc" @click="less" v-if="current != 0">
        <img src="@/assets/img/mobile/20.png" class="right-icon" alt="">
      </div>
      <div v-else class="ajc">
        <img src="@/assets/img/mobile/18.png" class="right-icon" alt="">
      </div>
      <div class="number"><span>{{ current + 1 }}</span> / {{ list.length }}</div>
      <div class="right ajc" @click="add" v-if="current + 1 < list.length">
        <img src="@/assets/img/mobile/21.png" class="right-icon" alt="">
      </div>
      <div v-else class="ajc">
        <img src="@/assets/img/mobile/19.png" class="right-icon" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/mobile/Title'
export default {
  components: {
    Title
  },
  data() {
    return {
      list: [],
      current: 0, // 当前索引
      isAnimated: false,
      timer: null,
      scrollItemWidth: 100 //当前滚动节点li每一项的宽度
    }
  },
  mounted() {
    this.getData()

  },
  methods: {
    // 监听盒子内部滚动，动态计算当前位置 
    handleScroll(e) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        const scrollLeft = e.target.scrollLeft
        let current = Math.ceil(scrollLeft / this.scrollItemWidth)
        this.current = current
      }, 100);
    },
    less() {
      this.current -= 1
      const scrollBox = this.$refs.scrollbox
      // 获取当前的 scrollLeft 值
      const currentScrollLeft = scrollBox.scrollLeft
      // 设置滚动值为 150px
      // scrollBox.scrollLeft = currentScrollLeft - this.scrollItemWidth
      scrollBox.scrollLeft = this.scrollItemWidth * this.current
    },
    add() {
      this.current += 1
      const scrollBox = this.$refs.scrollbox
      // 获取当前的 scrollLeft 值
      const currentScrollLeft = scrollBox.scrollLeft
      // scrollBox.scrollLeft = currentScrollLeft + this.scrollItemWidth
      scrollBox.scrollLeft = this.scrollItemWidth * this.current

      // 设置标记，触发动画效果
      // this.isAnimated = true
      // // 一段时间后，取消动画效果
      // setTimeout(() => {
      //   this.isAnimated = false
      // }, 500)
    },
    async getData() {
      const [err, res] = await this.$http.get('node')
      if (err) return
      this.list = res.list
      this.$nextTick(() => {
        // 获取每个li节点的宽度
        const scrollItem_0 = this.$refs.scrollItem_0
        this.scrollItemWidth = scrollItem_0[0].offsetWidth
      })
    }
  }
}
</script>

<style scoped lang="less"> .page5-box {
   width: 100%;
   height: 8rem;
   //  border: 1px solid red;
   //  display: flex;
   overflow: auto;
   position: relative;

   &::-webkit-scrollbar {
     display: none;
   }

   .ul-box {
     position: absolute;
     top: 50%;
     transform: translateY(-50%);
     //  overflow: auto;
     display: flex;

     .item {
       width: 4.6667rem;
       height: 1px;
       background: #979797;
       position: relative;

       .content {
         width: 3.2rem;
         position: absolute;
         left: 50%;
         transform: translate(-50%);
         top: var(--top);

         .desc {
           font-weight: bold;
           font-size: .3733rem;
         }

         .date {
           margin-top: .1333rem;
           font-size: .3467rem;
           color: #666;
         }
       }

       &::before {
         content: '';
         width: .12rem;
         height: .12rem;
         border-radius: .6667rem;
         background: #F7931E;
         position: absolute;
         left: 0;
         top: 50%;
         transform: translateY(-50%);
       }

       &:nth-last-child(1) {
         &::after {
           content: '';
           width: .12rem;
           height: .12rem;
           border-radius: .6667rem;
           background: #F7931E;
           position: absolute;
           right: 0;
           top: 50%;
           transform: translateY(-50%);
         }
       }

     }
   }
 }

 .cutover {
   width: 3.4rem;
   margin: 0.8267rem auto 0;

   .right-icon {
     width: .2667rem;
     height: .2667rem;
   }

   .number {
     font-weight: bold;

     span {
       font-size: .3733rem;
       color: #E28A2B;
     }
   }

   .right,
   .left {
     width: 0.9rem;
     height: 0.9rem;
     background: #E28B2B;
     box-shadow: 0 .1333rem .5333rem rgba(226, 139, 43, 0.5);
     border-radius: .6667rem;
     color: #FFF;
   }
 }

 /* 这里定义一个名为 `move` 的动画，会从 `0` 过渡到 `100` */
 @keyframes move {
   from {
     transform: translateX(0);
   }

   to {
     transform: translateX(100px);
   }
 }

 /* 给 `.scroll-box` 元素添加 `move` 动画效果 */
 .scroll-box {
   animation: move .5s ease-out;
 }
</style>